var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45.882,
    viewBox: "0 0 60 45.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(-529.6 -355.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M8.647,85.294A2.647,2.647,0,1,0,6,82.647,2.647,2.647,0,0,0,8.647,85.294Z",
    transform: "translate(523.6 316.507)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M28.647,59.294A2.647,2.647,0,1,0,26,56.647,2.647,2.647,0,0,0,28.647,59.294Z",
    transform: "translate(521.247 319.565)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M9,77.561l17.647-22.5L45.3,63.885,63.68,36.773",
    transform: "translate(523.248 321.592)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M49.647,69.294A2.647,2.647,0,1,0,47,66.647,2.647,2.647,0,0,0,49.647,69.294Z",
    transform: "translate(518.777 318.389)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M70.647,39.294A2.647,2.647,0,1,0,68,36.647,2.647,2.647,0,0,0,70.647,39.294Z",
    transform: "translate(516.306 321.918)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(529.6 370.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M9.035,53.2l17.714,8.823L45.2,44.106,63.84,48.258",
    transform: "translate(-6.357 -41.733)",
    fill: "none",
    stroke: "#bf0a76",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M8.647,70.294A2.647,2.647,0,1,0,6,67.647,2.647,2.647,0,0,0,8.647,70.294Z",
    transform: "translate(-6 -56.177)",
    fill: "#bf0a76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M28.647,80.294A2.647,2.647,0,1,0,26,77.647,2.647,2.647,0,0,0,28.647,80.294Z",
    transform: "translate(-8.353 -57.353)",
    fill: "#bf0a76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M49.647,60.294A2.647,2.647,0,1,0,47,57.647,2.647,2.647,0,0,0,49.647,60.294Z",
    transform: "translate(-10.824 -55)",
    fill: "#bf0a76",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M70.647,64.294A2.647,2.647,0,1,0,68,61.647,2.647,2.647,0,0,0,70.647,64.294Z",
    transform: "translate(-13.294 -55.471)",
    fill: "#bf0a76",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart3);
export default __webpack_public_path__ + "static/media/chart3.0eff49a37f4e928b5857e5cb79bf9190.svg";
export { ForwardRef as ReactComponent };